import { Injectable } from '@angular/core';

import { AnalyticsPeriod } from '../models/account-analytics';

const MS_IN_DAY = 1000 * 3600 * 24;

@Injectable({
  providedIn: 'root',
})
export class AccountAnalyticsService {
  public buildPeriods(): AnalyticsPeriod[] {
    const now = Date.now();
    const today = Math.floor(now / MS_IN_DAY) * MS_IN_DAY;

    return [
      {
        title: 'account-analytics.period.today',
        label: 'today',
        from: new Date(today),
        to: new Date(now),
        daysReplacement: 0,
      },
      {
        title: 'account-analytics.period.yesterday',
        label: 'yesterday',
        from: new Date(today - MS_IN_DAY),
        to: new Date(today - 1),
        daysReplacement: 0,
      },
      {
        title: 'account-analytics.period.last-days',
        label: '7days',
        from: new Date(today - MS_IN_DAY * 7),
        to: new Date(today - 1),
        daysReplacement: 7,
      },
      {
        title: 'account-analytics.period.last-days',
        label: '30days',
        from: new Date(today - MS_IN_DAY * 30),
        to: new Date(today - 1),
        daysReplacement: 30,
      },
      {
        title: 'account-analytics.period.last-days',
        label: '90days',
        from: new Date(today - MS_IN_DAY * 90),
        to: new Date(today - 1),
        daysReplacement: 90,
      },
      {
        title: 'account-analytics.period.last-days',
        label: '180days',
        from: new Date(today - MS_IN_DAY * 180),
        to: new Date(today - 1),
        daysReplacement: 180,
      },
      {
        title: 'account-analytics.period.last-days',
        label: '365days',
        from: new Date(today - MS_IN_DAY * 365),
        to: new Date(today - 1),
        daysReplacement: 365,
      },
    ];
  }
}
